var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2912_3091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.2218,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2912_3091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7407 17.7083C8.01484 17.7083 8.24464 17.6085 8.43009 17.4089C8.61555 17.2092 8.70827 16.9618 8.70827 16.6667C8.70827 16.3715 8.61555 16.1241 8.43009 15.9245C8.24464 15.7248 8.01484 15.625 7.7407 15.625C7.46655 15.625 7.23675 15.7248 7.0513 15.9245C6.86585 16.1241 6.77313 16.3715 6.77313 16.6667C6.77313 16.9618 6.86585 17.2092 7.0513 17.4089C7.23675 17.6085 7.46655 17.7083 7.7407 17.7083ZM7.7407 13.5417C8.01484 13.5417 8.24464 13.4418 8.43009 13.2422C8.61555 13.0425 8.70827 12.7951 8.70827 12.5C8.70827 12.2049 8.61555 11.9575 8.43009 11.7578C8.24464 11.5582 8.01484 11.4583 7.7407 11.4583C7.46655 11.4583 7.23675 11.5582 7.0513 11.7578C6.86585 11.9575 6.77313 12.2049 6.77313 12.5C6.77313 12.7951 6.86585 13.0425 7.0513 13.2422C7.23675 13.4418 7.46655 13.5417 7.7407 13.5417ZM7.7407 9.375C8.01484 9.375 8.24464 9.27517 8.43009 9.07552C8.61555 8.87587 8.70827 8.62847 8.70827 8.33333C8.70827 8.03819 8.61555 7.7908 8.43009 7.59115C8.24464 7.39149 8.01484 7.29167 7.7407 7.29167C7.46655 7.29167 7.23675 7.39149 7.0513 7.59115C6.86585 7.7908 6.77313 8.03819 6.77313 8.33333C6.77313 8.62847 6.86585 8.87587 7.0513 9.07552C7.23675 9.27517 7.46655 9.375 7.7407 9.375ZM10.6434 17.7083H16.4489V15.625H10.6434V17.7083ZM10.6434 13.5417H16.4489V11.4583H10.6434V13.5417ZM10.6434 9.375H16.4489V7.29167H10.6434V9.375ZM4.83798 21.875C4.30581 21.875 3.85025 21.671 3.47128 21.263C3.09232 20.855 2.90283 20.3646 2.90283 19.7917V5.20833C2.90283 4.63542 3.09232 4.14497 3.47128 3.73698C3.85025 3.32899 4.30581 3.125 4.83798 3.125H18.384C18.9162 3.125 19.3717 3.32899 19.7507 3.73698C20.1297 4.14497 20.3192 4.63542 20.3192 5.20833V19.7917C20.3192 20.3646 20.1297 20.855 19.7507 21.263C19.3717 21.671 18.9162 21.875 18.384 21.875H4.83798Z",
    fill: "#D6D6D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGray);
export default __webpack_public_path__ + "static/media/list-gray.b121c7310327730a180e3011032927ba.svg";
export { ForwardRef as ReactComponent };